const NOTAS_SUSTENIDO = ['C','C#','D','D#','E','F','F#','G','G#','A','A#','B'];
const NOTAS_BEMOL     = ['C','Db','D','Eb','E','F','Gb','G','Ab','A','Bb','B'];
const PREFERENCIA_BEMOL = ['F','Bb','Eb','Ab','Db','Gb','Cb'];

function indexDaNota(nota) {
    let idx = NOTAS_SUSTENIDO.indexOf(nota);
    if (idx === -1) idx = NOTAS_BEMOL.indexOf(nota);
    return idx;
}

// Regex central — usado em todos os lugares
const SUFIXO = '(7M|M7|maj7|maj|min|dim|aug|sus2|sus4|sus|add|m(?=[^a]|$))?';
const NUM    = '(\\d+)?';
const BAIXO  = '(\\/([A-G][#b]?))?';

// Testa se um token é um acorde válido
export function isAcorde(token) {
    if (!token) return false;
    const t = token.trim();
    if (t.length < 1 || t.length > 12) return false;
    // Bloqueia palavras comuns (Deus, Amen, etc.) MAS permite sufixos musicais (maj, sus, dim...)
    const falsosPositivos = /^[A-G][a-z]{3,}/.test(t);
    const ehSufixoValido  = /^[A-G][#b]?(maj|min|sus|dim|aug|add)/.test(t);
    if (falsosPositivos && !ehSufixoValido) return false;
    // Aceita: C, Cm, C#, Am7, F7M, FM7, Cmaj7, Csus4, C4, C/G, Am7/E, Gmaj7, etc.
    return /^[A-G][#b]?(maj7?|m(?!aj\d|in\d)|min|dim|aug|sus[24]?|add\d*)?(\d+)?(M7?|7M)?(\/[A-G][#b]?)?$/.test(t);
}

export function ehLinhaDeAcordes(linha) {
    const trimmed = linha.trim();
    if (!trimmed) return false;
    // Seções entre colchetes ou parênteses com só acordes são linhas de acorde
    if (/^\[.*\]$/.test(trimmed)) return false; // [Intro] etc — seção
    // Linha entre parênteses como ( C C4 C ) — trata como acorde
    const semParenteses = trimmed.replace(/^\(|\)$/g,'').trim();
    const tokens = semParenteses.split(/\s+/).filter(Boolean);
    if (!tokens.length) return false;
    const qtd = tokens.filter(isAcorde).length;
    return qtd > 0 && qtd / tokens.length >= 0.5;
}

export function transporCifra(cifra, semitons) {
    if (!cifra || semitons === 0) return cifra || "";
    // Regex robusto para acordes com todos os sufixos e baixo
    const REGEX = /([A-G][#b]?)(7M|M7|maj7|maj|min|dim|aug|sus2|sus4|sus|add|m(?=[^a]|$))?(\d+)?(\/([A-G][#b]?))?(?=\s|$|\))/g;
    return cifra.split('\n').map(linha => {
        if (!ehLinhaDeAcordes(linha)) return linha;
        return linha.replace(REGEX, (match, nota, sufixo, num, _, baixo) => {
            const idxAtual = indexDaNota(nota);
            if (idxAtual === -1) return match;
            const idxNovo = ((idxAtual + semitons) % 12 + 12) % 12;
            const preferirBemol = PREFERENCIA_BEMOL.includes(NOTAS_SUSTENIDO[idxNovo]);
            const novaNota = preferirBemol ? NOTAS_BEMOL[idxNovo] : NOTAS_SUSTENIDO[idxNovo];
            let novoBaixo = '';
            if (baixo) {
                const idxB = indexDaNota(baixo);
                if (idxB !== -1) {
                    const idxNB = ((idxB + semitons) % 12 + 12) % 12;
                    const prefB = PREFERENCIA_BEMOL.includes(NOTAS_SUSTENIDO[idxNB]);
                    novoBaixo = '/' + (prefB ? NOTAS_BEMOL[idxNB] : NOTAS_SUSTENIDO[idxNB]);
                } else novoBaixo = '/' + baixo;
            }
            return `${novaNota}${sufixo||''}${num||''}${novoBaixo}`;
        });
    }).join('\n');
}

// detectarTom(tomOriginal, semitons) → calcula tom transposto
// detectarTom(cifra) → detecta o tom a partir da primeira linha de acordes (modo legado)
export function detectarTom(arg1, semitons) {
    // Modo: (tomOriginal string curto, semitons number)
    if (typeof semitons === 'number') {
        const tomOriginal = arg1;
        if (!semitons) return tomOriginal;
        const idx = indexDaNota(tomOriginal);
        if (idx === -1) return tomOriginal;
        const novoIdx = ((idx + semitons) % 12 + 12) % 12;
        const novaNota = NOTAS_SUSTENIDO[novoIdx];
        return PREFERENCIA_BEMOL.includes(novaNota) ? NOTAS_BEMOL[novoIdx] : novaNota;
    }
    // Modo legado: (cifra) → detecta pela primeira linha de acordes
    const cifra = arg1;
    if (!cifra) return 'C';
    for (const linha of cifra.split('\n')) {
        if (ehLinhaDeAcordes(linha)) {
            const match = linha.match(/[A-G][#b]?/);
            if (match) return match[0];
        }
    }
    return 'C';
}

export function calcularCapotraste(tomOriginal, semitonsAdicionar) {
    const idx = indexDaNota(tomOriginal);
    if (idx === -1) return [];
    return Array.from({ length: 8 }, (_, capo) => {
        const semitonTocar = ((semitonsAdicionar - capo) % 12 + 12) % 12;
        const idxTocar = ((idx + semitonTocar) % 12 + 12) % 12;
        const preferirBemol = PREFERENCIA_BEMOL.includes(NOTAS_SUSTENIDO[idxTocar]);
        return { capo, tomTocar: preferirBemol ? NOTAS_BEMOL[idxTocar] : NOTAS_SUSTENIDO[idxTocar] };
    });
}

export const TONS = ['C','C#','Db','D','Eb','E','F','F#','Gb','G','Ab','A','Bb','B'];

export const DIAGRAMAS_VIOLAO = {
    'C':    {posicao:1,cordas:[-1,3,2,0,1,0]},
    'C#':   {posicao:4,cordas:[-1,4,6,6,6,4],barra:4},
    'Db':   {posicao:4,cordas:[-1,4,6,6,6,4],barra:4},
    'D':    {posicao:1,cordas:[-1,-1,0,2,3,2]},
    'Eb':   {posicao:1,cordas:[-1,-1,1,3,4,3]},
    'E':    {posicao:1,cordas:[0,2,2,1,0,0]},
    'F':    {posicao:1,cordas:[1,1,2,3,3,1],barra:1},
    'F#':   {posicao:2,cordas:[2,2,4,4,4,2],barra:2},
    'Gb':   {posicao:2,cordas:[2,2,4,4,4,2],barra:2},
    'G':    {posicao:1,cordas:[3,2,0,0,3,3]},
    'Ab':   {posicao:4,cordas:[4,4,6,6,6,4],barra:4},
    'A':    {posicao:1,cordas:[-1,0,2,2,2,0]},
    'Bb':   {posicao:1,cordas:[-1,1,3,3,3,1],barra:1},
    'B':    {posicao:2,cordas:[-1,2,4,4,4,2],barra:2},
    'Cm':   {posicao:3,cordas:[-1,3,5,5,4,3],barra:3},
    'C#m':  {posicao:4,cordas:[-1,4,6,6,5,4],barra:4},
    'Dbm':  {posicao:4,cordas:[-1,4,6,6,5,4],barra:4},
    'Dm':   {posicao:1,cordas:[-1,-1,0,2,3,1]},
    'Ebm':  {posicao:3,cordas:[-1,3,5,5,4,3],barra:3},
    'Em':   {posicao:1,cordas:[0,2,2,0,0,0]},
    'Fm':   {posicao:1,cordas:[1,1,3,3,2,1],barra:1},
    'F#m':  {posicao:2,cordas:[2,2,4,4,3,2],barra:2},
    'Gbm':  {posicao:2,cordas:[2,2,4,4,3,2],barra:2},
    'Gm':   {posicao:3,cordas:[3,3,5,5,4,3],barra:3},
    'Abm':  {posicao:4,cordas:[4,4,6,6,5,4],barra:4},
    'Am':   {posicao:1,cordas:[-1,0,2,2,1,0]},
    'Bbm':  {posicao:1,cordas:[-1,1,3,3,2,1],barra:1},
    'Bm':   {posicao:2,cordas:[-1,2,4,4,3,2],barra:2},
    'G7':   {posicao:1,cordas:[3,2,0,0,0,1]},
    'C7':   {posicao:1,cordas:[-1,3,2,3,1,0]},
    'D7':   {posicao:1,cordas:[-1,-1,0,2,1,2]},
    'E7':   {posicao:1,cordas:[0,2,0,1,0,0]},
    'A7':   {posicao:1,cordas:[-1,0,2,0,2,0]},
    'B7':   {posicao:2,cordas:[-1,2,4,2,4,2]},
    'F7':   {posicao:1,cordas:[1,1,2,1,3,1],barra:1},
    'Am7':  {posicao:1,cordas:[-1,0,2,0,1,0]},
    'Em7':  {posicao:1,cordas:[0,2,0,0,0,0]},
    'Dm7':  {posicao:1,cordas:[-1,-1,0,2,1,1]},
    'Bm7':  {posicao:2,cordas:[-1,2,4,2,3,2],barra:2},
    'Cm7':  {posicao:3,cordas:[-1,3,5,3,4,3],barra:3},
    'Fm7':  {posicao:1,cordas:[1,1,3,1,2,1],barra:1},
    'F#m7': {posicao:2,cordas:[2,2,4,2,3,2],barra:2},
    'Gm7':  {posicao:3,cordas:[3,3,5,3,4,3],barra:3},
    'Gmaj7':{posicao:1,cordas:[3,2,0,0,0,2]},
    'Fmaj7':{posicao:1,cordas:[1,1,2,2,1,0]},
    'Cmaj7':{posicao:1,cordas:[-1,3,2,0,0,0]},
    'Dmaj7':{posicao:1,cordas:[-1,-1,0,2,2,2]},
    'Amaj7':{posicao:1,cordas:[-1,0,2,1,2,0]},
    'F7M':  {posicao:1,cordas:[1,1,2,2,1,0],barra:1},
    'FM7':  {posicao:1,cordas:[1,1,2,2,1,0],barra:1},
};

export const DIAGRAMAS_PIANO = {
    'C':[0,4,7],'Cm':[0,3,7],
    'C#':[1,5,8],'Db':[1,5,8],
    'D':[2,6,9],'Dm':[2,5,9],
    'Eb':[3,7,10],'E':[4,8,11],'Em':[4,7,11],
    'F':[5,9,0],'Fm':[5,8,0],
    'F#':[6,10,1],'Gb':[6,10,1],
    'G':[7,11,2],'Gm':[7,10,2],
    'Ab':[8,0,3],'A':[9,1,4],'Am':[9,0,4],
    'Bb':[10,2,5],'B':[11,3,6],'Bm':[11,2,6],
    'Am7':[9,0,4,7],'Em7':[4,7,11,2],'Dm7':[2,5,9,0],
    'Bm7':[11,2,6,9],'Cm7':[0,3,7,10],'Fm7':[5,8,0,3],
    'G7':[7,11,2,5],'C7':[0,4,7,10],'D7':[2,6,9,0],
    'E7':[4,8,11,2],'A7':[9,1,4,7],'B7':[11,3,6,9],
    'F7':[5,9,0,3],'F7M':[5,9,0,4],'FM7':[5,9,0,4],
    'Gmaj7':[7,11,2,6],'Fmaj7':[5,9,0,4],
    'Cmaj7':[0,4,7,11],'Dmaj7':[2,6,9,1],'Amaj7':[9,1,4,8],
};

export const NOTAS_ACORDE = {
    'C':'Dó · Mi · Sol','Cm':'Dó · Mib · Sol',
    'C#':'Dó# · Fá · Sol#','Db':'Réb · Fá · Láb',
    'D':'Ré · Fá# · Lá','Dm':'Ré · Fá · Lá',
    'Eb':'Mib · Sol · Sib','E':'Mi · Sol# · Si','Em':'Mi · Sol · Si',
    'F':'Fá · Lá · Dó','Fm':'Fá · Láb · Dó',
    'F#':'Fá# · Lá# · Dó#','Gb':'Solb · Sib · Réb',
    'G':'Sol · Si · Ré','Gm':'Sol · Sib · Ré',
    'Ab':'Láb · Dó · Mib','A':'Lá · Dó# · Mi','Am':'Lá · Dó · Mi',
    'Bb':'Sib · Ré · Fá','B':'Si · Ré# · Fá#','Bm':'Si · Ré · Fá#',
    'Am7':'Lá·Dó·Mi·Sol','Em7':'Mi·Sol·Si·Ré','Dm7':'Ré·Fá·Lá·Dó',
    'Bm7':'Si·Ré·Fá#·Lá','Cm7':'Dó·Mib·Sol·Sib','Fm7':'Fá·Láb·Dó·Mib',
    'G7':'Sol·Si·Ré·Fá','C7':'Dó·Mi·Sol·Sib','D7':'Ré·Fá#·Lá·Dó',
    'F7':'Fá·Lá·Dó·Mib','F7M':'Fá·Lá·Dó·Mi','FM7':'Fá·Lá·Dó·Mi',
    'A7':'Lá·Dó#·Mi·Sol','B7':'Si·Ré#·Fá#·Lá','E7':'Mi·Sol#·Si·Ré',
    'Gmaj7':'Sol·Si·Ré·Fá#','Fmaj7':'Fá·Lá·Dó·Mi',
    'Cmaj7':'Dó·Mi·Sol·Si','Dmaj7':'Ré·Fá#·Lá·Dó#',
};
// ─ Aliases para o App.js ─────────────────────────────────────
export const TONS_UI = ['C','C#','D','D#','E','F','F#','G','G#','A','A#','B'];
export const DIAGS_VIOLAO = DIAGRAMAS_VIOLAO;
export const DIAGS_PIANO  = DIAGRAMAS_PIANO;
export function notasDoAcorde(acorde) {
    return NOTAS_ACORDE[acorde] || '';
}